import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Pin, Megaphone } from "lucide-react";

export default function Notices() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get("/notices");
        if (!cancelled) setItems(res.data || []);
      } catch {
        if (!cancelled) setItems([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <section
      id="notices"
      data-testid="notices-section"
      className="relative py-24 md:py-32 bg-[#0a0a0a] border-y border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="w-10 h-px bg-[#d4af37]" />
              <span className="text-xs uppercase tracking-[0.3em] text-[#d4af37] font-bold">
                Notice Board
              </span>
            </div>
            <h2 className="font-heading text-5xl md:text-6xl uppercase leading-[0.9]">
              Latest from <br />
              <span className="text-[#d4af37]">The Gym.</span>
            </h2>
          </div>
          <p className="text-white/60 max-w-sm text-sm md:text-base">
            Schedule changes, seminars, fight nights and gym news. Check here first.
          </p>
        </div>

        {loading ? (
          <div className="text-white/50 text-sm uppercase tracking-[0.2em]">
            Loading…
          </div>
        ) : items.length === 0 ? (
          <div
            data-testid="notices-empty"
            className="border border-dashed border-white/15 p-12 text-center"
          >
            <Megaphone className="mx-auto text-[#d4af37] mb-4" size={32} />
            <div className="font-heading text-2xl uppercase">No notices yet</div>
            <p className="mt-2 text-sm text-white/60">
              Check back soon for updates from the coaches.
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {items.map((n) => (
              <article
                key={n.id}
                data-testid={`notice-${n.id}`}
                className={`relative border p-7 bg-[#050505] transition-colors ${
                  n.pinned
                    ? "border-[#d4af37]/60"
                    : "border-white/10 hover:border-white/25"
                }`}
              >
                {n.pinned && (
                  <span className="absolute top-4 right-4 inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.25em] font-bold text-[#d4af37]">
                    <Pin size={12} /> Pinned
                  </span>
                )}
                <div className="text-[11px] uppercase tracking-[0.25em] text-white/40">
                  {new Date(n.created_at).toLocaleDateString("en-AU", {
                    day: "numeric",
                    month: "short",
                    year: "numeric",
                  })}
                </div>
                <h3 className="mt-2 font-heading text-2xl md:text-3xl uppercase leading-tight">
                  {n.title}
                </h3>
                <p className="mt-4 text-white/75 text-sm md:text-base whitespace-pre-line leading-relaxed">
                  {n.body}
                </p>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
